import { motion } from "framer-motion";

const TermsAndConditions = () => {
  return (
    <div className="bg-gray-50 dark:bg-black min-h-screen py-24 px-4 sm:px-6 lg:px-10">
      <div className="max-w-5xl mx-auto">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-black dark:text-white">
            Terms & Conditions
          </h1>

          <p className="mt-4 text-gray-600 dark:text-gray-400 text-lg">
            Please read these terms carefully before using our platform.
          </p>
        </motion.div>

        {/* Content */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mt-14 bg-white dark:bg-[#111] rounded-3xl shadow-lg border border-gray-200 dark:border-gray-800 p-6 sm:p-10 space-y-10"
        >

          {/* TERMS */}
          <section>
            <h2 className="text-2xl font-bold text-[#106EE8] mb-5">
              Terms & Conditions
            </h2>

            <div className="space-y-5 text-gray-700 dark:text-gray-300 leading-8">
              <p>
                The Website Owner, including subsidiaries and affiliates
                (“Website” or “Website Owner” or “we” or “us” or “our”)
                provides the information contained on the website or any of the
                pages comprising the website (“website”) to visitors
                (“visitors”) subject to the terms and conditions set out in
                these website terms and conditions, the privacy policy and any
                other relevant terms and conditions.
              </p>

              <p>
                Welcome to our website. If you continue to browse and use this
                website you are agreeing to comply with and be bound by the
                following terms and conditions of use, which together with our
                privacy policy govern CLINICAL AI ASSISTANCE PRIVATE LIMITED's
                relationship with you in relation to this website.
              </p>

              <p>
                The term ‘CLINICAL AI ASSISTANCE PRIVATE LIMITED’ or ‘us’ or
                ‘we’ refers to the owner of the website whose
                registered/operational office is:
              </p>

              <div className="bg-gray-100 dark:bg-black rounded-2xl p-5">
                <p className="font-semibold">
                  47 MOTT LN, KOLKATA,
                  <br />
                  WEST BENGAL - 700013
                </p>
              </div>

              <div className="space-y-4">
                {[
                  "The content of the pages of this website is for your general information and use only. It is subject to change without notice.",
                  "Neither we nor any third parties provide any warranty or guarantee regarding the accuracy, timeliness, performance, completeness or suitability of the information found on this website.",
                  "Your use of any information or materials on this website is entirely at your own risk.",
                  "This website contains material which is owned by or licensed to us including design, layout, graphics and appearance.",
                  "All trademarks reproduced in this website are acknowledged appropriately.",
                  "Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offence.",
                  "This website may include links to other websites for additional information.",
                  "You may not create a link to this website without prior written consent from CLINICAL AI ASSISTANCE PRIVATE LIMITED.",
                  "Your use of this website and any dispute arising out of such use is subject to the laws of India.",
                  "We shall not be liable for any loss arising directly or indirectly from declined payment authorizations.",
                ].map((item, index) => (
                  <div
                    key={index}
                    className="flex gap-4 items-start"
                  >
                    <div
                      className="min-w-[32px] h-8 rounded-full 
                      bg-[#106EE8] text-white flex items-center justify-center text-sm font-semibold"
                    >
                      {index + 1}
                    </div>

                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* PRIVACY POLICY */}
          <section>
            <h2 className="text-2xl font-bold text-[#106EE8] mb-5">
              Privacy Policy
            </h2>

            <div className="space-y-5 text-gray-700 dark:text-gray-300 leading-8">
              <p>
                CLINICAL AI ASSISTANCE PRIVATE LIMITED is committed to ensuring
                that your privacy is protected. Any information collected from
                you will only be used in accordance with this privacy statement.
              </p>

              <p>
                We may collect the following information:
              </p>

              <ul className="list-disc pl-6 space-y-2">
                <li>Name and job title</li>
                <li>Contact information including email address</li>
                <li>
                  Demographic information such as postcode, preferences and
                  interests
                </li>
                <li>
                  Other information relevant to customer surveys and/or offers
                </li>
              </ul>

              <h3 className="text-xl font-semibold mt-6">
                How We Use Cookies
              </h3>

              <p>
                A cookie is a small file placed on your device to help analyze
                web traffic and improve your website experience. Cookies allow
                applications to tailor operations to your needs and preferences.
              </p>

              <p>
                We use cookies for traffic analysis and improving website
                performance. Cookies do not provide access to your computer or
                personal information beyond what you choose to share.
              </p>

              <h3 className="text-xl font-semibold mt-6">
                Controlling Your Personal Information
              </h3>

              <ul className="list-disc pl-6 space-y-2">
                <li>
                  You may restrict the collection or use of personal
                  information for marketing purposes.
                </li>

                <li>
                  You can contact us anytime to stop receiving promotional
                  communications.
                </li>

                <li>
                  We do not sell, distribute, or lease your personal
                  information to third parties without your permission unless
                  required by law.
                </li>

                <li>
                  If you believe any information we hold is incorrect, please
                  contact us for correction.
                </li>
              </ul>

              <div className="bg-gray-100 dark:bg-black rounded-2xl p-5 mt-6">
                <p className="font-semibold">
                  Contact Email:
                </p>

                <p className="mt-2">
                  healthcareaiassistance@gmail.com
                </p>
              </div>
            </div>
          </section>

          {/* REFUND POLICY */}
          <section>
            <h2 className="text-2xl font-bold text-[#106EE8] mb-5">
              Cancellation & Refund Policy
            </h2>

            <div className="bg-gray-100 dark:bg-black rounded-2xl p-6">
              <p className="text-gray-700 dark:text-gray-300 leading-8">
                No cancellations or refunds are entertained.
              </p>
            </div>
          </section>

          {/* SHIPPING */}
          <section>
            <h2 className="text-2xl font-bold text-[#106EE8] mb-5">
              Shipping & Delivery Policy
            </h2>

            <div className="bg-gray-100 dark:bg-black rounded-2xl p-6">
              <p className="text-gray-700 dark:text-gray-300 leading-8">
                Shipping is not applicable for this business.
              </p>
            </div>
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsAndConditions;